import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "row gy-5 gx-xl-8 pb-5" }
const _hoisted_2 = { class: "col-xxl-8" }
const _hoisted_3 = { class: "card-header border-0 pt-5" }
const _hoisted_4 = { class: "card-title align-items-start flex-column" }
const _hoisted_5 = { class: "card-label fw-bolder fs-3 mb-1" }
const _hoisted_6 = { class: "text-muted mt-1 fw-bold fs-7" }
const _hoisted_7 = { class: "card-toolbar" }
const _hoisted_8 = { class: "d-flex align-items-center position-relative my-1" }
const _hoisted_9 = { class: "svg-icon svg-icon-1 position-absolute ms-6" }
const _hoisted_10 = ["placeholder"]
const _hoisted_11 = { class: "card-body py-3" }
const _hoisted_12 = {
  key: 0,
  class: "d-flex justify-content-center mt-15"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border spinner-lg",
  role: "status"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Loading...")
], -1)
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = {
  key: 1,
  class: "table-responsive"
}
const _hoisted_16 = { class: "text-gray-800 mb-1" }
const _hoisted_17 = { class: "form-check form-check-sm form-check-custom form-check-solid" }
const _hoisted_18 = { class: "col-xxl-4" }
const _hoisted_19 = { class: "mb-5 mb-xl-8" }
const _hoisted_20 = {
  key: 0,
  class: "card"
}
const _hoisted_21 = { class: "card-body d-flex flex-column p-0" }
const _hoisted_22 = { class: "card-body d-flex flex-column" }
const _hoisted_23 = { class: "text-muted" }
const _hoisted_24 = { class: "mx-8" }
const _hoisted_25 = { class: "fw-bolder fs-6" }
const _hoisted_26 = { class: "fw-bolder fs-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_attendance = _resolveComponent("attendance")!
  const _component_KTDatatable = _resolveComponent("KTDatatable")!
  const _component_AttendanceChart = _resolveComponent("AttendanceChart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass(["card", _ctx.widgetClasses])
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h3", _hoisted_4, [
            _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.t('classInfo.register')), 1),
            _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.t('attendance.sessions', {
                  date: _ctx.moment().format('DD/MM/YYYY'),
                })), 1)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("span", _hoisted_9, [
                _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen021.svg" })
              ]),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.search) = $event)),
                class: "form-control form-control-solid w-200px ps-15",
                placeholder: _ctx.t('student.findSubject')
              }, null, 8, _hoisted_10), [
                [_vModelText, _ctx.search]
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          (!_ctx.loadedAttendance)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, _hoisted_14))
            : _createCommentVNode("", true),
          (_ctx.loadedAttendance)
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                _createVNode(_component_KTDatatable, {
                  "table-data": _ctx.filtredSchedule,
                  "table-header": _ctx.tableHeader,
                  "enable-items-per-page-dropdown": false,
                  rowsPerPage: 40,
                  loading: _ctx.loading
                }, {
                  "cell-name": _withCtx(({ row: schedule }) => [
                    _createElementVNode("div", _hoisted_16, _toDisplayString(schedule.name ? schedule.name : schedule.subject.name), 1)
                  ]),
                  "cell-attendance": _withCtx(({ row: schedule }) => [
                    _createElementVNode("div", _hoisted_17, [
                      (schedule._id !== '')
                        ? (_openBlock(), _createBlock(_component_attendance, {
                            id: _ctx.student._id,
                            schedule: schedule._id,
                            key: _ctx.student._id,
                            attendances: _ctx.attendances
                          }, null, 8, ["id", "schedule", "attendances"]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _: 1
                }, 8, ["table-data", "table-header", "loading"])
              ]))
            : _createCommentVNode("", true)
        ])
      ], 2)
    ]),
    _createElementVNode("div", _hoisted_18, [
      _createElementVNode("div", _hoisted_19, [
        (_ctx.loadedAttendance)
          ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _createVNode(_component_AttendanceChart, {
                  "widget-classes": "card-xl-stretch mb-5 mb-xl-8",
                  height: 250,
                  title: _ctx.t('attendance.attendanceState'),
                  description: _ctx.t('attendance.titleState'),
                  data: _ctx.attendance
                }, null, 8, ["title", "description", "data"])
              ]),
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("h5", _hoisted_23, _toDisplayString(_ctx.t('attendance.inThisYear')), 1),
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("div", null, [
                    _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.t('attendance.totalAbsents', {
                      nb: _ctx.attendanceData.Absence,
                    })), 1)
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.t('attendance.totalDelays', { nb: _ctx.attendanceData.Retard })), 1)
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}